<template>
  <transition name="slide-up">
    <div v-if="isVisible" class="modal-container">
      <div class="modal-header">
        <!-- Left-aligned Title -->
        <h3 class="modal-title">{{ title }}</h3>
        <!-- Right-aligned Close Button -->
        <button class="close-btn" @click="closeModal">
          <span class="close-text">Close <i class="fas fa-times close-icon"></i></span>
        </button>
      </div>
      <div class="modal-content">
        <!-- Display Image or PDF Content -->
        <div v-if="isImage" class="image-wrapper">
          <div v-if="isImageLoading" class="loader">Loading...</div>
          <img 
            v-if="content"
            :src="content" 
            class="content-image" 
            alt="Case Study Image" 
            @load="onImageLoad"
            :style="{ visibility: isImageLoading ? 'hidden' : 'visible' }"
          />
        </div>
        <!-- PDF Viewer with script injection to disable right-click -->
        <iframe 
          v-if="isPdf && content" 
          :src="content + '#toolbar=0&navpanes=0&scrollbar=0'" 
          width="100%" 
          height="100%" 
          class="pdf-viewer" 
          
        ></iframe>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "BottomSheetModal",
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    content: {
      type: String,
      required: true,
    },
    isImage: {
      type: Boolean,
      required: true,
    },
    isPdf: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      isImageLoading: true,
    };
  },
  // No computed properties needed after removing pdfViewerUrl
  methods: {
    closeModal() {
      this.$emit("close");
    },
    disableRightClickInIframe(event) {
      const iframe = event.target;

      // Ensure the iframe is fully loaded before attempting to access its content
      iframe.contentWindow.addEventListener("contextmenu", (e) => {
        e.preventDefault();
      });
    },
    onImageLoad() {
      this.isImageLoading = false;
    },
  },
  watch: {
    isVisible(newVal) {
      if (newVal && this.isImage) {
        this.isImageLoading = true;
      }
    }
  }
};
</script>

<style>
/* Container for the Modal */
.modal-container {
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%) translateY(0);
  width: 84vw;
  height: 88vh;
  background: var(--color-bg-white);
  transition: transform var(--duration-slow) var(--ease-in-out);
  z-index: 1000;
  overflow-y: auto;
  padding: 0;
  border: 2px solid var(--color-border);
}

/* Modal Header */
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px var(--space-5);
  background: var(--color-bg-subtle);
  font-size: var(--text-sm);
  height: 50px;
  border-bottom: 1px solid var(--color-border);
}

/* Left-aligned Modal Title */
.modal-title {
  margin: 0;
  flex-grow: 1;
  text-align: left;
}

/* Close Button */
.close-btn {
  border: 2px solid var(--color-bg-darker);
  cursor: pointer;
  font-size: var(--text-sm);
  display: flex;
  align-items: center;
  transition: color var(--duration-slow) var(--ease-out);
}

.close-btn:hover {
  color: var(--color-primary-light) !important;
}

/* Close Button Text */
.close-text {
  color: var(--color-bg-white);
}

/* Modal Content */
.modal-content {
  padding: var(--space-5) 0;
  height: calc(88vh - 50px);
}

/* Image Wrapper */
.image-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
}

/* Loader */
.loader {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: var(--text-xl);
  color: var(--color-text-700);
}

/* Content Image */
.content-image {
  width: 100% !important;
  max-width: 100%;
  height: auto;
  max-height: calc(88vh - 50px);
  object-fit: contain;
  display: block;
  margin: 0 auto;
}

/* PDF Viewer Styling */
.pdf-viewer {
  width: 100% !important;
  height: 100%;
  border: none;
}

/* Animation */
.slide-up-enter-active,
.slide-up-leave-active {
  transition: all var(--duration-slow) var(--ease-out);
}

.slide-up-enter,
.slide-up-leave-to {
  transform: translateY(100%);
  opacity: 0;
}
</style>